import { render } from "./ContactUsAction.vue?vue&type=template&id=028110e8&scoped=true"
import script from "./ContactUsAction.vue?vue&type=script&lang=js"
export * from "./ContactUsAction.vue?vue&type=script&lang=js"

import "./ContactUsAction.vue?vue&type=style&index=0&id=028110e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028110e8"]])

export default __exports__